var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company_info"},[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":_vm.companyWeb,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.companyWeb))])])
}
var staticRenderFns = []

export { render, staticRenderFns }